import {dataHooks} from '@wix/data-hooks'

export const timeSlotsListExtendedDataHooks = dataHooks<{
  root: {}
}>('time-slots-list-extended')
